import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _extends from 'babel-runtime/helpers/extends';
import _Map from 'babel-runtime/core-js/map';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _get from 'lodash/get';
import _camelCase from 'lodash/camelCase';
import _memoize from 'lodash/memoize';
import _pick from 'lodash/pick';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Arrow from '@wh/svg-icons/ArrowRight';
import ThemeConsumer from '@sitebase/theme-context/es/ThemeConsumer';

import { getAllowedAttributes } from '../../props-filters';
import propTypeClassName from '../../propTypeClassName';
import { makeOutfitParser, category, flattenValues } from '../../outfit-parser';
import outfitPropValidator from '../../outfitPropValidator';
import { parseAnchorOutfit, anchorOutfits } from './anchor-outfit';
import { parseButtonOutfit, buttonOutfits } from '../Button/button-outfit';
import * as style from '../buttons.style';
import { ButtonGroupContextConsumer } from '../button-group-context';

var anchorType = 'anchor';
var buttonType = 'button';
var DEFAULT_OUTFIT = 'primary';

var anchorPropsNames = {
  hrefSpecific: ['download', 'href', 'hrefLang', 'media', 'ping', 'referrerPolicy', 'rel', 'target', 'type', 'onBlur', 'onFocus', 'onKeyDown', 'onKeyPress', 'onKeyUp'],
  universal: ['id', 'onClick', 'onDbClick', 'onMouseDown', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onMouseEnter', 'onMouseLeave', 'onWheel']
};
var resolveTag = function resolveTag(root) {
  return root === 'span' ? 'span' : 'a';
};

var parseType = makeOutfitParser(category('types', [anchorType, buttonType]));
var getOutfitType = function getOutfitType(outfit) {
  var _parseType$get = parseType(outfit).get('types'),
      _parseType$get2 = _slicedToArray(_parseType$get, 1),
      type = _parseType$get2[0];

  return type || anchorType;
};
var parseOutfitByType = function parseOutfitByType(type, outfit, theme) {
  var _parsers;

  var parsers = (_parsers = {}, _defineProperty(_parsers, anchorType, parseAnchorOutfit), _defineProperty(_parsers, buttonType, parseButtonOutfit), _parsers);
  return parsers[type] ? parsers[type](outfit, theme) : new _Map();
};

var getAnchorProps = function getAnchorProps(props) {
  return _extends({}, _pick(props, anchorPropsNames.universal), props.href ? _pick(props, anchorPropsNames.hrefSpecific) : {});
};

var mergeOutfits = function mergeOutfits() {
  var outfit1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var outfit2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return DEFAULT_OUTFIT + ' ' + outfit1 + ' ' + outfit2;
};

var getStyleNames = _memoize(function (theme, outfit) {
  var type = getOutfitType(outfit);
  var styles = parseOutfitByType(type, outfit, theme);
  return cx(style.anchor, style[_camelCase(type + '-outfit')], style[_camelCase(type + '-theme-' + theme)], flattenValues(styles).map(function (value) {
    return style[_camelCase(type + '-' + value)];
  }));
}, function (theme, outfit) {
  return theme + ' ' + outfit;
});

var Anchor = function (_PureComponent) {
  _inherits(Anchor, _PureComponent);

  function Anchor() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Anchor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Anchor.__proto__ || _Object$getPrototypeOf(Anchor)).call.apply(_ref, [this].concat(args))), _this), _this._renderAnchorWithTheme = function (theme) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          buttonGroupOutfit = _ref2.buttonGroupOutfit;

      var _this$props = _this.props,
          anchorOutfit = _this$props.outfit,
          children = _this$props.children,
          outerRender = _this$props.outerRender,
          className = _this$props.className;

      var outfit = mergeOutfits(buttonGroupOutfit, anchorOutfit);
      var allowedAttributes = getAllowedAttributes(_this.props);
      var anchorProps = getAnchorProps(_this.props);
      var styleNames = getStyleNames(theme, outfit);
      var type = getOutfitType(outfit);
      var parsedOutfit = parseOutfitByType(type, outfit, theme);
      var withArrow = Boolean(_get(parsedOutfit.get('arrows'), 'size'));
      var classNames = cx(styleNames, className);

      var render = function render() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            root = _ref3.root;

        var Tag = resolveTag(root);
        var props = Tag === resolveTag('default') ? _extends({}, anchorProps, allowedAttributes) : {};
        return React.createElement(
          Tag,
          _extends({}, props, { className: classNames }),
          React.createElement(
            'span',
            { className: style.anchorLabel },
            children,
            withArrow && React.createElement(Arrow, { className: style.anchorArrow })
          )
        );
      };

      return outerRender ? outerRender(render) : render();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Anchor, [{
    key: 'render',


    /* eslint-disable no-underscore-dangle */
    value: function render() {
      var _this2 = this;

      return React.createElement(
        ThemeConsumer,
        null,
        function (theme) {
          return React.createElement(
            ButtonGroupContextConsumer,
            null,
            function (buttonGroupContext) {
              return _this2._renderAnchorWithTheme(theme, buttonGroupContext);
            }
          );
        }
      );
    }
  }]);

  return Anchor;
}(PureComponent);

Anchor.propTypes = {
  /** The Anchor children. Input goes to flex container so it can be aligned internally */
  children: PropTypes.node,
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   *
   * Options:
   *
   * - Types: "**button**", "**anchor**". Each type has its own additional options:
   *  - For "**anchor**" it is:
   *    - Anchor presets:
   *      - "**primary**" (in light-theme resolves to: "blue"; while in dark-theme resolves to: "yellow"),
   *      - "**secondary**" (resolves to: "gray"),
   *      - "**paragraph**" (in light-theme resolves to: "blue underlined"; while in dark-theme resolves to: "yellow").
   *      - "**tooltip**" (resolves to: "white underlined semi-transparent").
   *    - Colors: "**blue**", "**yellow**", "**gray**", "**white**", "**inherit**" (inherits color from parent; states like hover, active, visited etc.).
   *    - Modifiers: "**underlined**", "**semi-transparent**"(opacity 0.7, hover: opacity 1).
   *    - Arrows: "**arrow-up**", "**arrow-down**", "**arrow-right**"
   *  - For "**button**" it is:
   *    - Button presets:
   *      - "**primary**" (resolves to: "yellow" and "normal"),
   *      - "**secondary**" (resolves to: "yellow", "hollow" and "normal"),
   *      - "**tertiary**" (resolves to: "light-blue" and "normal"),
   *      - "**quaternary**" (in light-theme resolves to: "blue" and "normal"; while in dark-theme mode it resolves to: "white" and "normal").
   *    - Colors: "**blue**", "**light-blue**", "**yellow**", "**green**", "**orange**", "**red**", "**white**".
   *    - Sizes: "**tiny**", "**small**", "**normal**", "**large**", "**x-large**".
   *    - Modifiers: "**hollow**", "**expanded**" (multi choice).
   */
  outfit: outfitPropValidator([anchorType, buttonType].concat(_toConsumableArray(buttonOutfits), _toConsumableArray(anchorOutfits))),
  /**
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   *
   * @param {function} render - renders the component's appearance. Accepts one optional parameter:
   *  the configuration object with the optional property "root" which can have one of two values:
   *  "default" or "span". "default" refers to the "a" HTML element and "span" refers to the "span" HTML element.
   */
  outerRender: PropTypes.func,
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   */
  className: propTypeClassName,
  /** Native attribute */
  download: PropTypes.string,
  /** Native attribute */
  href: PropTypes.string,
  /** Native attribute */
  hrefLang: PropTypes.string,
  /** Native attribute */
  id: PropTypes.string,
  /** Native attribute */
  media: PropTypes.string,
  /** Native attribute */
  ping: PropTypes.string,
  /** Native attribute */
  referrerPolicy: PropTypes.string,
  /** Native attribute */
  rel: PropTypes.string,
  /** Native attribute */
  target: PropTypes.string,
  /** Native attribute */
  title: PropTypes.string,
  /** Native attribute */
  type: PropTypes.string,
  /** Native attribute */
  onBlur: PropTypes.func,
  /** Native attribute */
  onClick: PropTypes.func,
  /** Native attribute */
  onDbClick: PropTypes.func,
  /** Native attribute */
  onFocus: PropTypes.func,
  /** Native attribute */
  onKeyDown: PropTypes.func,
  /** Native attribute */
  onKeyPress: PropTypes.func,
  /** Native attribute */
  onKeyUp: PropTypes.func,
  /** Native attribute */
  onMouseDown: PropTypes.func,
  /** Native attribute */
  onMouseEnter: PropTypes.func,
  /** Native attribute */
  onMouseLeave: PropTypes.func,
  /** Native attribute */
  onMouseMove: PropTypes.func,
  /** Native attribute */
  onMouseOut: PropTypes.func,
  /** Native attribute */
  onMouseOver: PropTypes.func,
  /** Native attribute */
  onMouseUp: PropTypes.func,
  /** Native attribute */
  onWheel: PropTypes.func
};


export default Anchor;